import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@unite-us/client-utils';
import { get, isEmpty } from 'lodash';
import ProgramContactCard from './ProgramContactCard';

const ProgramContactInfo = ({ serviceCase }) => {
  const referrals = get(serviceCase, 'referrals', []);
  if (!referrals.length) return null;

  const getContactInfo = (referral) => {
    const provider = get(referral, 'receiving_provider', {});
    const program = get(referral, 'receiving_program', {});
    const category = get(referral, 'category', '');
    const text = get(referral, 'text', '');
    const programPhones = get(program, 'phone_numbers', []);
    const providerPhones = get(provider, 'phone_numbers', []);
    const programEmails = get(program, 'email_addresses', []);
    const providerEmails = get(provider, 'email_addresses', []);
    const phones = !isEmpty(programPhones) ? programPhones : providerPhones;
    const emails = !isEmpty(programEmails) ? programEmails : providerEmails;
    return {
      programName: category === 'external_provider' ? text : get(program, 'name', ''),
      organizationName: get(provider, 'name', ''),
      phones,
      emails,
    };
  };

  return (
    <div className="program-contact-info mb-4">
      <div className="mt-4">
        <h5 className="detail-info__icon-label mb-3">Programs/Organizations</h5>
        <Banner
          content={(<>Contact these programs directly to connect this client to services.</>)}
          variant="alert"
          dismissible={false}
        />
        <div className="row">
          {referrals.map((referral, index) => {
            const contactInfo = getContactInfo(referral);
            return (
              <ProgramContactCard key={`referral-${referral.id || index}`} contactInfo={contactInfo} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

ProgramContactInfo.propTypes = {
  serviceCase: PropTypes.shape({
    referrals: PropTypes.array,
  }).isRequired,
};

export default ProgramContactInfo;
